<template>
  <ul ref="rootRef" class="lp-acc">
    <li
      v-for="(item, index) in props.items"
      :key="index"
      class="lp-acc__item"
      :class="{ 'is-open': openIndex === index }"
    >
      <button
        class="lp-acc__row"
        type="button"
        :aria-expanded="openIndex === index"
        :aria-controls="`${props.idPrefix}-copy-${index}`"
        @click="toggle(index)"
      >
        <span class="lp-acc__num">{{ String(index + 1).padStart(2, "0") }}</span>
        <span class="lp-acc__title">{{ item.title }}</span>
        <span class="lp-acc__sign" aria-hidden="true"></span>
      </button>

      <!-- Grid-rows transition rather than max-height, so the copy animates to
           its real height without a magic number. -->
      <div :id="`${props.idPrefix}-copy-${index}`" class="lp-acc__copy">
        <div class="lp-acc__copy-inner">
          <!-- eslint-disable-next-line vue/no-v-html -- trusted translation copy -->
          <p class="lp-acc__para" v-html="item.text"></p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { ref } from "vue";

/*
 * The one accordion on this page. "Who we are" and the FAQ are the same
 * component deliberately: same numerals, same plus/minus mark, same open and
 * close animation. The FAQ used to reuse the site's shared faq-item, but that
 * one is a v-if with an opacity fade on enter and no leave transition, so it
 * appeared and then snapped shut — visibly different from this one.
 */
export interface AccordionItem {
  title: string;
  /** HTML — translation copy only, never user input. */
  text: string;
}

const props = defineProps<{
  items: AccordionItem[];
  /** Prefix for the aria-controls ids, so two accordions can share a page. */
  idPrefix: string;
}>();

const emit = defineEmits<{
  (e: "change", open: number | null): void;
}>();

// null is the neutral state: every row closed. Only one row is ever open, and
// clicking the open row closes it back to neutral.
const openIndex = ref<number | null>(null);
const rootRef = ref<HTMLElement>();

const toggle = (index: number): void => {
  openIndex.value = openIndex.value === index ? null : index;
  emit("change", openIndex.value);
};

defineExpose({ rootRef });
</script>
